import { LessonType } from '../../api/lesson';
import Segment from '../shared/segment';

export type LessonTitlePropsType = {
  lesson: LessonType;
};

function LessonTitle({ lesson }: LessonTitlePropsType) {
  return (
    <Segment
      bg
      color='sky'
      noMargin
      textAlign='center'
      className='sticky mt-2 mb-1 text-lg font-medium'
    >
      <p>سوالات درس {lesson.name}</p>
    </Segment>
  );
}

export default LessonTitle;
